import {useEffect} from "react";
import {useThemeContext} from "../theming/ThemeContext";
import {useSessionContext} from "../context/SessionContext";
import {getQueryParam} from "../utility/navigationUtil";
import {PARAMETER_CAMPAIGN_ID, PARAMETER_CHANNEL_ID, PARAMETER_TEASER_CONTACT_EMAIL,} from "../pages/config/settings";

export const useInitializeSession = (segment: string) => {
    const {setTheme} = useThemeContext();
    const {addToSession} = useSessionContext();

    useEffect(() => {
        setTheme(segment);
        if (typeof window !== "undefined") {
            const search = window.location.search;
            const channelId = getQueryParam(search, PARAMETER_CHANNEL_ID);
            if (channelId) {
                addToSession(PARAMETER_CHANNEL_ID, channelId);
            }
            const campaignId = getQueryParam(search, PARAMETER_CAMPAIGN_ID);
            if (campaignId) {
                addToSession(PARAMETER_CAMPAIGN_ID, campaignId);
            }
            const contactEmail = getQueryParam(search, PARAMETER_TEASER_CONTACT_EMAIL);
            if (contactEmail) {
                addToSession(PARAMETER_TEASER_CONTACT_EMAIL, contactEmail);
            }
        }
    }, [segment, setTheme, addToSession]);
};
